module.exports = __webpack_public_path__ + "img/snakeresc.a96bdebe.png";